module.exports = __webpack_public_path__ + "static/img/foundation-8m-x-4m_256.c063b17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/foundation-8m-x-4m_256.png
// module id = Wgka
// module chunks = 0